import React, { useState, useEffect,useRef } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import pausewave from '../assets/images/pause.jpg'
import '../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CallLog from "./calllog"
import { Hangup, Resume, Pause, Logout,FetchDispo } from '../redux/action/login';
import '../assets/css/webphone.css';
import JsSIP from 'jssip';
import person from "../assets/images/person.svg"
import Incomingcallscreen from '../page/inboundpage';
// import api from "../../utils/axios-util.js";
// import { faIcon1, faIcon2 } from '@fortawesome/free-solid-svg-icons';
import api from "../utils/axios-util";
import {
    faEye,
    faPlus,
    faMicrophone,
    faMicrophoneSlash,
    faPhoneSlash,
    faPause,
    faPlay,
    faUsers,
    faShareSquare,
    faUserAstronaut,

} from '@fortawesome/free-solid-svg-icons';
import Comtemplete from '../page/comtemplete';
import { setIbLeadDetailsaction } from '../redux/Ibleaddetails/leadaction';
import { setSession } from '../redux/RTCSession/sessionAction';
import { setcallInfo } from '../redux/CallInfo/callinfoAction';
import ringtoneSrc from '../assets/audio/ringtone.wav';
function formatCallDuration(durationInSeconds) {
    const minutes = Math.floor(durationInSeconds / 60).toString().padStart(2, '0');
    const seconds = (durationInSeconds % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
}
function DisplayURLParameters() {

    const dispatch = useDispatch();
    const user_name1 = localStorage.getItem("username")
    const [tenantid, setTenantId] = useState("")
    const [useremail, setUserEmail] = useState("")
    const [entity_type, setEntityType] = useState("")
    const [user_id, setUserId] = useState("")
    const [entity_id, setEntityId] = useState("")

    const [response, setResponse] = useState("")
    const [phone, setPhone] = useState("");
    const [callStatus, setCallStatus] = useState('On Call1'); // Initialize as 'idle'
    const [pause, setPause] = useState(false);
    const [awayOptionsOpen, setAwayOptionsOpen] = useState(false); // New state variable
    const [badge, setBadge] = useState('Offline'); // Initialize with the default status
    const [isDispositionSelected, setIsDispositionSelected] = useState(false);
    const [webphone, setWebphone] = useState(false);

    const [callername, setcallername] = useState('');
    const [callernumber, setCallernumber] = useState("");
    const [leadname, setLeadName] = useState("Unknown Name");//incomingcall
    const [station, setStation] = useState("");
    const [incomingscreen, setIncomingscreen] = useState(false);
    const [inboundcall, setInboundcall] = useState(false); // show + and eye icon in IB call
    const [incominganswer, setIncominganswer] = useState(false); //set to session  event
    const [sipOptions, setsipOptions] = useState({
        mediaConstraints: {
            audio: true,
            video: false,
        },
    })
    const [callDuration, setCallDuration] = useState(0);
    const [isMuted, setIsMuted] = useState(false);
    const [isOnHold, setIsOnHold] = useState(false);
    const [callStartTime, setCallStartTime] = useState(null);
    const [incomingdetails, setIncomingdetails] = useState(false);
    const [dispositionStatusOptions,setDispositionStatusOptions] = useState("")
    // const dispositionStatusOptions = [
    //     'Not Started',
    //     'In Progress',
    //     'Completed',
    //     // Add more disposition status options as needed
    // ];
    const [callNotes, setCallNotes] = useState('');
    const [dispositionStatus, setDispositionStatus] = useState('');
    const [incomingdata, setIncomingdata] = useState("")
    const [inboundnumber, setInboundnumber] = useState("")
    //Inbound lead detail
    const [ibleadowner, setIbLeadOwner] = useState("")
    const [ibleaddate, setIbLeadDate] = useState("")
    const [ibleadid, setIbLeadId] = useState("")
    const [starttimer, setStarttimer] = useState(false)
    const [callended, setCallended] = useState(true)
    const [crmownername,setcrmownername]= useState('')
    const ringtoneRef = useRef(new Audio(ringtoneSrc));
    
    const getconfigdata = localStorage.getItem('config')
    const getconfig = JSON.parse(getconfigdata)
    let webrtcdomain = getconfig.projects[0].config[0].webrtc_domain
    let webrtc_ip = getconfig.projects[0].config[0].webrtc_ip
    let station2 = getconfig.projects[0].userInfo[0].user_phone_number
    // let station2 = localStorage.getItem('station')
    const unregisterWebRTC = () => {
        if (phone) {
            phone.unregister(); // Unregister from the SIP server
            localStorage.setItem('resume', JSON.stringify(false))
        }
    };

    const toggleMute = () => {
        setIsMuted(!isMuted);

        if (response) {
            if (isMuted) {
                response.unmute();
                setCallStatus('oncall');
            } else {
                response.mute();
                setCallStatus('mute');
            }
        }
    };


    const toggleHold = () => {
        setIsOnHold(!isOnHold);

        if (response) {
            if (isOnHold) {
                response.unhold();
                setCallStatus('oncall');
            } else {
                response.hold();
                setCallStatus('hold');
            }
        }
    };

    const crmaddlead = () => {
        console.log("incomingdata--------------->", crmownername);
        const todayDate = new Date().toISOString().split('T')[0];
        const leadincomingnum = incomingdata["Mobile Number"]
        return new Promise(async (resolve, reject) => {
            const payload = {
                "records": [
                    {
                        "Lead Date": todayDate,
                        "Contact Name": "NEWLEAD",
                        "Mobile Number": inboundnumber,
                        "Stage": "NEW LEADS",
                        "Lead Owner": crmownername
                    }
                ]

            }

            await api
                .post(`https://apps.cratiocrm.com/api/apirequest.php?apikey=NF8xXzM0MTMkQDQ0IyMyMDI0LTAxLTI1IDE1OjAzOjI5&formname=Leads&operation=insertRecords&overwrite=true`, payload)

                .then((response) => {
                    console.log("inserleadapi", response);
                    toast.success('Lead Create successful!', {
                        position: toast.POSITION.TOP_CENTER, // Set toast position

                    });
                    resolve(response);
                })
                .catch((err) => {
                    reject("inserterror", err);
                    toast.success('Alread Lead Created!', {
                        position: toast.POSITION.TOP_CENTER, // Set toast position

                    });
                });
        });
        // Implement transfer functionality
    };
    const crmviewlead = () => {
        console.log("incomingdataviewwwwwwwwwwwwwwww", incomingdata["Form ID"]);
        const formid = incomingdata["Form ID"]
        window.open(`https://wa.cratiocrm.com/#/crm?form=leads&formid=${formid}`, '_blank');

        // Implement conference functionality
    };
    const handleCallNotesChange = (event) => {
        setCallNotes(event.target.value);
    };
    const handleDispositionStatusChange = (event) => {
        const selectedStatus = event.target.value;
        setDispositionStatus(selectedStatus);
        setIsDispositionSelected(!!selectedStatus);
    };
    const handleHangup = () => {



        setCallStatus('ended');
        setWebphone(false)
        const payload = {
            "station": station,
            "phone_number": callernumber,
            "tenant_id": tenantid,
            "entity_type": entity_type,
            "user_id": user_id,
            "entity_id": entity_id,
            "agent": { "identity": "user", "value": user_name1 },
            "call_status": dispositionStatus,
            "description": callNotes
        }

        dispatch(Hangup(payload))
            .then((disporesponse) => {
                if (disporesponse.status === 200) {

                    console.log("Call-logPayload", payload);
                    response.terminate();

                }


            })
            .catch((err) => {
                console.log("errrrrrrrrr", err);
            });

        // if (callended) {
        //     console.log("callended==========>", callended);
        //     response.terminate();
        // }


        resetCallDuration();
        setCallNotes("");
        setDispositionStatus("");

    };
    const fetchDispo = async () => {
        dispatch(FetchDispo())
    .then((response) => {
      if (response.status === 200) {
        let data = JSON.stringify(response.data)
        console.log("DispoResponseData123=========>",response.data.data);
        const dispodata =response.data.data
        const extractedDisopNames = dispodata.map(dispo => dispo.dispo_id);
        setDispositionStatusOptions(extractedDisopNames);
   
      }
      
    })
    .catch((err) => {
      
     console.log("FetchDispoerr===========>",err);
    });
    
    
        }

   
    

    const fetchinboundleaddata = async (number) => {
        console.log("Inboundatanumber================>", number);
        return new Promise(async (resolve, reject) => {
            // const apiToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOiJhdGxhbnRvc29mdCIsInVzZXJuYW1lIjoiYXRsYW50b3NvZnRfYWRtaW4iLCJzY29wZSI6ImFkbWluIiwiaXNzIjoiaHR0cHM6Ly9saXZlLWRvb2N0aS5hdS5hdXRoMC5jb20vIiwic3ViIjoiejZMMzlyekRhZmtub0tucjVWUHloMU8zRW9aVUxGUGRAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vcHJvZC1hcGkuZG9vY3RpLmNvbSIsImV4cCI6MTY2ODg3Mzk2ODk3MiwiaWF0IjoxNjA1ODAxOTY4fQ.f_TV2TheSK7ikg92MM91h6QN29BlUvxvMivr9fZcFKk";
            const configaccesstoken = "NF8xXzM0MTMkQDQ0IyMyMDI0LTAxLTI1IDE1OjAzOjI5";
            const leadnumber = number
            await api
                .get(`https://apps.cratiocrm.com/api/apirequest.php?apikey=${configaccesstoken}&formname=Leads&operation=getRecordsBySearch&pageno=1&numofrecords=100&sortcolumn=Contact Name&sortorder=desc&isnull=1&searchcondition=Mobile Number@is@${leadnumber}@AND$&templatename=API Result`)
                .then((response) => {
                    resolve(response);
                    const responsedata = response.data.data[0]
                    const leadinboundname = responsedata["Contact Name"]
                    const leadinboundid = responsedata["Form ID"]
                    const leadinbounddate = responsedata["Lead Date"]
                    const leadinboundowner = responsedata["Lead Owner"]


                    setLeadName(leadinboundname)
                    setcallername(leadinboundname)
                    setIbLeadId(leadinboundid)
                    setIbLeadDate(leadinbounddate)
                    setIbLeadOwner(leadinboundowner)
                    setIncomingdata(response.data.data[0]);
                    dispatch(setIbLeadDetailsaction(response.data.data[0]));
                    let dispatchdata = response.data.data[0]
                    dispatch(setcallInfo(dispatchdata));

                })
                .catch((err) => {
                    console.log("configapierrorin actionpage:", err);
                    reject(err);
                });
        });

    }



    const webrtc = async () => {
        // let station2 = '7358846062'


        console.log('station2=====================>', station2);

        localStorage.setItem('resume', JSON.stringify(true))
        let webrtcSocket = new JsSIP.WebSocketInterface(`wss://${webrtcdomain}/ws`);
        var configuration = {
            sockets: [webrtcSocket],
            display_name: station2,
            authorization_user: station2,
            // uri: 'sip:7358846062@web-phone.doocti.com',
            uri: `sip:${station2}@${webrtc_ip}`,
            password: station2,
            // realm: 'web-phone.doocti.com',
            realm: webrtc_ip,
            DtlsSrtpKeyAgreement: false,
            // contact_uri: 'sip:7358846062@web-phone.doocti.com',eb
            contact_uri: `sip:${station2}@${webrtc_ip}`,
            connection_recovery_min_interval: 5,
            connection_recovery_max_interval: 20,
            use_preloaded_route: true,
            session_timers: false,
            no_answer_timeout: 60000,
            register_expires: 30000000,
            // ws_servers: 'wss://web-phone.doocti.com/ws',
            ws_servers: `wss://${webrtc_ip}/ws`,
            trace_sip: true,
        };
        var coolPhone = new JsSIP.UA(configuration);

        coolPhone.start();
        setPhone(coolPhone);

        coolPhone.register();

        coolPhone.on('registered', function (e) {
            console.log(e, 'registered', '============>');
        });

        coolPhone.on('unregistered', function (e) {
            console.log(e, 'unregistered', '============>');
        });

        coolPhone.on('registrationFailed', function (e) {
            console.log(e, 'registrationFailed', '============>');
        });

        coolPhone.on('connected', function (e) {
            console.log(e, 'connected', '============>');
        });

        coolPhone.on('disconnected', function (e) {
            console.log(e, 'disconnected', '============>');
        });



        coolPhone.on('newRTCSession', function (e) {
            const session = e.session;

            session.on('confirmed', function () {
                if (session.originator === 'remote') {
                    // The customer (remote side) has accepted the call
                    console.log('Customer side accepted the call...');
                    // You can perform any actions you need when the customer side accepts the call
                }
            });


            session.on('ended', function (data) {
                setCallended(false)
                setCallStatus('ended');
                setLeadName(leadname)
                setcallername(callername)
                setStarttimer(false)
                setIncomingdetails(false)
                resetCallDuration();
                console.log("session Ended==============>");
            });
            session.on('hold', function (data) {
                // The call has been placed on hold

            });

            session.on('failed', function (data) {
                console.log("Failed==========>", data);
                ringtoneRef.current.pause();
                ringtoneRef.current.currentTime = 0;
              
                setIncomingscreen(false)
                setIncomingdetails(false);
                setInboundcall(false)
                setLeadName(leadname)
                resetCallDuration();
            });

            setResponse(session)
            dispatch(setSession(session));
            session.on('progress', function (e) {
                console.log('Progress...', e);
                setStarttimer(true)
                startCallDuration();
                setCallended(true)
                //  localStorage.setItem('setCallended',false)
            });

            // Determine if it's an incoming or outgoing call
            if (session.direction === 'outgoing') {
                // Handle outgoing call

                console.log('Outgoing call initiated to:');
            }
            else if (session.direction === 'incoming') {
                console.log('session.direction======================>',session);
                let callee_number = session._request.from.uri.user;
                setCallStatus('oncall');
                const headers = session._request.headers;
                const call_type = headers['Call-Info'][0].raw
                const cleanCallType = call_type.substring(3);
                const outbount_type = call_type.substring(16);
                console.log("InboundCall Dial Plan=========>", headers);
                if (cleanCallType === 'inbound') {
                    setInboundcall(true)
                    setIncomingscreen(true)
                    setIncominganswer(session)
                    ringtoneRef.current.loop = true;
                     ringtoneRef.current.play();
                    const countryCode = '+91';

                    let split_code = callee_number.replace(countryCode, '');

                    const getcrmuserinfo = localStorage.getItem('crmuserinfo');
                    const getcrmuserinfoobj = JSON.parse(getcrmuserinfo);
                    fetchinboundleaddata(split_code);
                    setCallernumber(split_code)
                    setInboundnumber(split_code);
                    const data = {
                        tenant_id: getcrmuserinfoobj.tenant_id,
                        user_id: getcrmuserinfoobj.user_id,
                        user_email: getcrmuserinfoobj.user_email,
                        user_number: getcrmuserinfoobj.user_number


                    };
                    console.log("Ib call post data==========>", data);
                    window.parent.postMessage(data, '*');

                }
                if (outbount_type === 'manual') {
                    console.log("Auto Answer Condition");
                    setInboundcall(false)
                    setTimeout(function () {
                        session.answer(sipOptions)
                    }, 500)

                }
                else {
                    console.log("Auto Answer Failed");

                }

                session.on('peerconnection', function (data) {
                    data.peerconnection.addEventListener('addstream', function (e) {
                        let remoteAudio = document.createElement('audio')
                        remoteAudio.srcObject = e.stream
                        remoteAudio.play()

                        // sound(false)
                    })
                })
            }
        });

    }




    const startCallDuration = () => {
        if (!callStartTime) {
            setCallStartTime(new Date());
        }
    };
    const resetCallDuration = () => {
        setCallStartTime(null);
        setCallDuration(0);
    };

    useEffect(() => {
        
        window.addEventListener('message', incomingresponse);

    }, [])

    const incomingresponse = async (event) => {

        let inboundlead_name = event.data.lead_name
        if (inboundlead_name) {
            // setcallername(inboundlead_name)
            setLeadName(inboundlead_name)
            setcallername(inboundlead_name)
        }



    }
   useEffect(()=>{
    fetchDispo();
   },[])

    useEffect(() => {
        const crmname = localStorage.getItem('config')
        const crmowner_name = JSON.parse(crmname).projects[0].userInfo[0].user_name
        if (callername == "" || callername == null || callername == undefined ) {
            setcallername("Unkown Name")
        }
        setcrmownername(crmowner_name)
        if (callStartTime) {
            const timer = setInterval(() => {
                const currentTime = new Date();
                const durationInSeconds = Math.floor((currentTime - callStartTime) / 1000);
                setCallDuration(durationInSeconds);
            }, 1000);

            return () => {
                clearInterval(timer);
            };
        }
       
        window.addEventListener('message', handleMessage);
        return () => {

            console.log("Removelistener")

            window.removeEventListener('message', handleMessage);

        };


    }, [callStartTime]);

    const handleMessage = async (event) => {
        try {
            console.log("C2C Event Data:", event.data);
            const api_domain = JSON.parse(localStorage.getItem('token'))
            let dispatchdata1 = event.data
            dispatch(setcallInfo(dispatchdata1));
            const apiToken = api_domain.access_token;
            const stationnumber = event.data.user_number
            const user_id = event.data.user_id
            const lead_id1 = event.data.entity_id
            const module = event.data.entity_type
            const entity_number = event.data.entity_number
            const entity_name = event.data.entity_name
            const tenant_id = event.data.tenant_id
            const user_email = event.data.user_email
            setStation(stationnumber)
            setEntityId(lead_id1)
            setUserId(user_id)
            setEntityType(module)
            setcallername(entity_name)
            setTenantId(tenant_id)
            setUserEmail(user_email)
            setCallernumber(entity_number)
            const payload = {
                station: station2,
                phone_number: entity_number,
                agent: {
                    identity: 'user',
                    value: user_name1,
                },
                custdata: {
                    lead_id: lead_id1,
                    module: module,

                },
            };
            return new Promise(async (resolve, reject) => {

                await api.post(`/api/crm/call`, payload,
                    {
                        headers: {
                            Authorization: `Bearer ${apiToken}`,
                        },
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        localStorage.setItem('callstatus', JSON.stringify(response.status));
                        setWebphone(true)
                    }
                    else{
                        setPause(true)
                    }
                })
                    .catch((err) => {
                        console.log("Error", err.response.status);

                       
                         if (err.response.status == 401) {
                            localStorage.removeItem('login');
                            localStorage.removeItem('hanguppayload');
                            localStorage.removeItem('resume');
                            localStorage.removeItem('agentstatus');
                            localStorage.removeItem('config');
                            localStorage.removeItem('username');
                            localStorage.removeItem('apinfo');
                            localStorage.removeItem('token');
                            localStorage.removeItem('callstatus');
                            localStorage.removeItem('queuelogin');
                            localStorage.removeItem('crmuserinfo');
                            localStorage.removeItem('entititytype');
                            localStorage.removeItem('station');
                            window.location.href = `/`;

                        }
                        else{
                            setPause(true)
                        }
                        localStorage.setItem('callstatus', JSON.stringify(err.response.status));

                    });
            });
        } catch (error) {
            console.error('Error making call:', error);
        }




    };

    const answercall = async () => {
        incominganswer.answer(sipOptions)
        setIncomingdetails(true);
        setIncomingscreen(false);
        setWebphone(true);
        ringtoneRef.current.pause();
    ringtoneRef.current.currentTime = 0;
    }

    const declinecall = async () => {
        ringtoneRef.current.pause();
        ringtoneRef.current.currentTime = 0;
        incominganswer.terminate({
            status_code: 603,
            reason_phrase: 'Decline',
        });



    }






    function toggleUserOptions() {
        const userOptions = document.getElementById('userOptions');
        userOptions.style.display = userOptions.style.display === 'block' ? 'none' : 'block';
    }
    function logout() {

        const logutpayload = {
            user: user_name1,
            station: station
        }
        dispatch(Logout(logutpayload))

    }

    function HandleSetBadge(badge) {
        console.log('Selected status:', badge);

        const userOptions = document.getElementById('userOptions');
        userOptions.style.display = 'none';
        if (badge == "Online") {
            setBadge('Online')
            setPause(false)
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname
            }
            dispatch(Resume(payload))

            localStorage.setItem('agentstatus', true)

            webrtc();
            

        }
        else if (badge == "Away") {
            setBadge('Away')
            setAwayOptionsOpen(true);
            localStorage.setItem('agentstatus', false)
            unregisterWebRTC();

        } else if (badge == "Offline") {
            setBadge('Offline')
            localStorage.removeItem('agentstatus');
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname,
                "reason": "Break"
            }
            dispatch(Pause(payload))

        }
        else {
            setAwayOptionsOpen(false);
            const agentname = localStorage.getItem("username")
            const payload = {
                "user": agentname,
                "reason": badge
            }
            dispatch(Pause(payload))

        }
    }
    return (





        <div>
            {webphone ?

                (


                    <div className="webphone-container">


                        <div className='bgcolour'>

                            <div className="call-animation">
                                <img src={person} className="img-circle" alt="test" style={{ cursor: 'pointer' }} />
                                <div className="caller-info">
                                    <div> {callername} </div>
                                    <div>{callernumber}</div>
                            </div>
                            </div>
                            <div className="call-duration">
                                {formatCallDuration(callDuration)}
                                {callStatus === 'oncall' && <span>On Call</span>}
                                {callStatus === 'ended' && <span>Call Ended</span>}
                                {callStatus === 'failed' && <span></span>}
                                {callStatus === 'hold' && <span>On hold</span>}
                                {callStatus === 'mute' && <span>Mute</span>}

                            </div>

                            <div className="call-notes">
                                <textarea
                                    rows="4"
                                    value={callNotes}
                                    onChange={handleCallNotesChange}
                                    placeholder="Add call notes here"
                                ></textarea>
                            </div>

                            <div className="disposition-status-dropdown">
                                <select
                                    id="dispositionStatus"
                                    value={dispositionStatus}
                                    onChange={handleDispositionStatusChange}
                                    className="white-select"
                                    required

                                >
                                    <option value="">Select Disposition Status</option>
                                    {dispositionStatusOptions.map((option, index) => (
                                        <option key={index} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="webphone-icons">


                                <button onClick={toggleMute} style={{ color: '#53a9e5', fontSize: '15px' }} className={isMuted ? 'active' : ''}>
                                    <FontAwesomeIcon icon={isMuted ? faMicrophoneSlash : faMicrophone} />
                                    <div className="icon-label mute">Mute</div>
                                </button>


                                <button onClick={toggleHold} className={isOnHold ? 'active' : ''}>
                                    <FontAwesomeIcon icon={isOnHold ? faPlay : faPause} style={{ color: '#53a9e5', fontSize: '15px', }} />
                                    <div className="icon-label hold">Hold</div>
                                </button>

                                {inboundcall ? (
                                    <>
                                        <button onClick={crmaddlead}>
                                            <FontAwesomeIcon icon={faPlus} style={{ color: '#53a9e5', fontSize: '13px' }} />
                                            <div className="icon-label transfer">AddLead</div>
                                        </button>

                                        <button onClick={crmviewlead}>
                                            <FontAwesomeIcon icon={faEye} style={{ color: '#53a9e5', fontSize: '13px' }} />
                                            <div className="icon-label con">View Lead</div>
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button >
                                            <FontAwesomeIcon icon={faShareSquare} style={{ color: '#53a9e5', fontSize: '13px' }} />
                                            <div className="icon-label transfer">Transfer</div>
                                        </button>

                                        <button >
                                            <FontAwesomeIcon icon={faUsers} style={{ color: '#53a9e5', fontSize: '13px' }} />
                                            <div className="icon-label con">Conference</div>
                                        </button>
                                    </>
                                )}



                                <button onClick={handleHangup} disabled={!isDispositionSelected}>
                                    <FontAwesomeIcon icon={faPhoneSlash} style={{ color: 'red', fontSize: '13px', }} />
                                    <div className="icon-label hangup">Hangup</div>

                                </button>

                            </div>

                        </div>

                    </div>






                )

                : pause ? (
                    <div>
                        <Comtemplete
                            toggleUserOptions={toggleUserOptions}
                            badge={badge}
                            logout={logout}
                            handleSetBadge={HandleSetBadge}
                            awayOptionsOpen={awayOptionsOpen}
                        >
                            <div id="top" class="page-wrap">

                                <div className="agent-pause">
                                    <img class="pause-illust" src={pausewave}></img>
                                    <div className="pause-notes">User is offline</div>

                                </div>
                            </div>

                        </Comtemplete>





                    </div>
                ) : incomingscreen ? (
                    <div>
                        <Incomingcallscreen
                            onAnswer={answercall}
                            onDecline={declinecall}
                            leadname={leadname}
                            leadnumber={callernumber}
                            leadid={ibleadid}
                            leaddate={ibleaddate}
                            leadowner={ibleadowner}
                        />
                    </div>
                ) :

                    <div>
                        <Comtemplete
                            toggleUserOptions={toggleUserOptions}
                            badge={badge}
                            logout={logout}
                            handleSetBadge={HandleSetBadge}
                            awayOptionsOpen={awayOptionsOpen}
                        >
                            <div id="top" class="page-wrap">
                                <CallLog />


                            </div>
                        </Comtemplete>
                    </div>

            }
        </div>
    );

}

export default DisplayURLParameters;